<template lang="pug">
#race
  //- ui
  mute-button
</template>

<script>
import {mapState} from 'vuex'
// import Ui from './ui/Ui'
import MuteButton from './ui/MuteButton'
import game from 'src/components/game/main'
// import * as STAGES from 'src/config/stages'
import {service as AnalyticsService} from 'src/api/AnalyticsService'

export default {
  name: 'race',
  components: {
    // Ui,
    MuteButton
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapState('game', {
      // progress: state => state.progress
      stage: state => state.stage
    })
  },
  mounted () {
    AnalyticsService.sendPageview('/race')

    window.race = this
    game.restart()
  },
  beforeDestroy: function() {
    game.stop()
  },
  methods: {
    // restart () {
    //   game.restart()
    //   // this.$store.commit('game/restart')
    // }
    // end () {
    //   game.stop()
    //   // this.$store.commit('game/end')
    //   this.$router.replace('result')
    // }
  },
  watch: {
    // progress (val) {
    //   if (val >= 1) this.end()
    // }
    // stage (val) {
    //   if (val === STAGES.END) {
    //     this.$router.replace('result')
    //   }
    // }
  }
}
</script>

<style lang="sass" scoped>
@import "src/common.sass"

#race
  text-align: center
  pointer-events: none


</style>



// WEBPACK FOOTER //
// Race.vue?2d4bbced